var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-assistant__sider" },
    [
      _c(
        "div",
        { staticClass: "ai-assistant__sider__header" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "default", block: "" },
              on: { click: _vm.addChat },
            },
            [_c("a-icon", { attrs: { type: "plus" } }), _vm._v("新增会话")],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ai-assistant__sider__chat-list" },
        [
          _c(
            "a-space",
            {
              staticStyle: { position: "relative", width: "100%" },
              attrs: { direction: "vertical", size: 10 },
            },
            _vm._l(_vm.combinedTopics, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: {
                    "ai-assistant__sider__chat-card": true,
                    "ai-assistant__sider__chat-card--acitve":
                      _vm.isActiveSession(item),
                    "ai-assistant__sider__chat-card--edit":
                      item.mode === "edit",
                  },
                  attrs: { "data-key": item.key },
                  on: {
                    click: function ($event) {
                      return _vm.onClickTopic(item)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "ai-assistant__sider__chat-title" },
                    [
                      _vm.editingSessionId === item.session_id
                        ? _c("a-input", {
                            attrs: { size: "small", "max-length": 60 },
                            on: {
                              pressEnter: function ($event) {
                                return _vm.handleSubmit(item)
                              },
                            },
                            model: {
                              value: item.rename,
                              callback: function ($$v) {
                                _vm.$set(item, "rename", $$v)
                              },
                              expression: "item.rename",
                            },
                          })
                        : _c(
                            "span",
                            [
                              _c("a-icon", {
                                staticStyle: { "margin-right": "5px" },
                                attrs: {
                                  type:
                                    item.type === "teamSession"
                                      ? "team"
                                      : "user",
                                },
                              }),
                              _vm._v(" " + _vm._s(item.title) + " "),
                              item.isTopup
                                ? _c("a-icon", {
                                    staticStyle: {
                                      "margin-left": "5px",
                                      color: "#1E5AF9",
                                    },
                                    attrs: { type: "pushpin" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                      _vm.editingSessionId === item.session_id
                        ? _c(
                            "a-space",
                            {
                              staticClass: "ai-assistant__sider__chat-tools",
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: 3 },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "ai-assistant__sider__chat-tool",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleSubmit(item)
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", {
                                    staticStyle: { color: "#1E5AF9" },
                                    attrs: {
                                      type: "check-circle",
                                      theme: "filled",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "ai-assistant__sider__chat-tool",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleCancel(item)
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", {
                                    staticStyle: { color: "#F5222D" },
                                    attrs: {
                                      type: "close-circle",
                                      theme: "filled",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.editingSessionId !== item.session_id
                    ? _c(
                        "a-dropdown",
                        {
                          staticClass: "ai-assistant__sider__chat-more",
                          attrs: {
                            trigger: ["click"],
                            placement: "bottomRight",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "ai-assistant__sider__chat-more-icon",
                            },
                            [_c("a-icon", { attrs: { type: "ellipsis" } })],
                            1
                          ),
                          _c(
                            "a-menu",
                            { attrs: { slot: "overlay" }, slot: "overlay" },
                            [
                              _c(
                                "a-menu-item",
                                {
                                  key: "pin",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleTogglePin(item)
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", {
                                    attrs: {
                                      type: item.isTopup
                                        ? "pushpin"
                                        : "pushpin",
                                      theme: item.isTopup
                                        ? "filled"
                                        : "outlined",
                                    },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.isTopup ? "取消置顶" : "置顶"
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-menu-item",
                                {
                                  key: "edit",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(item)
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "edit" } }),
                                  _vm._v("编辑 "),
                                ],
                                1
                              ),
                              _c(
                                "a-menu-item",
                                {
                                  key: "delete",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(item)
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "delete" } }),
                                  _vm._v("删除 "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "ai-assistant__sider__chat-info" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getMessageCount(item)) + "条对话"),
                    ]),
                    _c("span", [_vm._v(_vm._s(item.updated_at))]),
                  ]),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _c("div", { staticClass: "assistant__sider__footer" }, [
        _c(
          "a",
          {
            staticClass: "assistant__sider__footer__action",
            on: { click: _vm.resetSessions },
          },
          [
            _c("a-icon", { attrs: { type: "delete" } }),
            _c(
              "div",
              { staticClass: "assistant__sider__footer__action-name" },
              [_vm._v("清除所有会话")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "ai-assistant__sider__header" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "default", block: "" },
              on: { click: _vm.handleAgentsShow },
            },
            [_c("a-icon", { attrs: { type: "plus" } }), _vm._v("我的智能体")],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "ai-assistant__sider__chat-list",
          staticStyle: { flex: "0 0 200px" },
        },
        [
          _c(
            "a-space",
            {
              staticStyle: { width: "100%" },
              attrs: { direction: "vertical", size: 10 },
            },
            _vm._l(_vm.userAgents, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: {
                    "ai-assistant__sider__chat-card": true,
                    "ai-assistant__sider__chat-card--acitve":
                      item.user_agent_id === _vm.user_agent_id,
                  },
                  attrs: { "data-key": item.key },
                  on: {
                    click: function ($event) {
                      return _vm.onClickAgent(item)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "ai-assistant__sider__chat-title" },
                    [_vm._v(_vm._s(item.agent_name))]
                  ),
                  _c(
                    "a-space",
                    {
                      staticClass: "ai-assistant__sider__chat-tools",
                      attrs: { size: 3 },
                    },
                    [
                      _c("a-tooltip", { attrs: { title: "删除" } }, [
                        _c(
                          "a",
                          {
                            staticClass: "ai-assistant__sider__chat-tool",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleUserAgentDelete(item)
                              },
                            },
                          },
                          [_c("a-icon", { attrs: { type: "delete" } })],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _c("team-topic-modal", { ref: "teamTopicModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }